export default {"src":"/_next/static/image/public/images/ic_video_call_blue_box.f7fb9c4ad1217f737b52b4671fe4b824.svg","height":28,"width":28};